<template>
  <b-modal
    @hide="closePopup"
    ref="instructionModal"
    dialog-class="info-modal__dialog"
    content-class="info-modal__content info-modal__content--hidden custom-modal-padding"
    body-class="info-modal pt-0"
    modal-class="info-modal info-modal--small"
    size="md"
    :visible="visible"
    v-if="visible"
    no-fade
    hide-body
    hide-header
    hide-footer
    hide-header-close
  >
    <button class="btn-close" @click="closePopup">
      <svg class="svg-popup-close-button" width="25" height="25" viewBox="0 0 25 25" fill="" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.8811 12.5L24.714 1.66715C25.0954 1.28575 25.0954 0.667394 24.714 0.286047C24.3326 -0.0953001 23.7142 -0.0953489 23.3329 0.286047L12.5 11.1189L1.66715 0.286047C1.28575 -0.0953489 0.667394 -0.0953489 0.286047 0.286047C-0.0953001 0.667443 -0.0953489 1.2858 0.286047 1.66715L11.1189 12.5L0.286047 23.3329C-0.0953489 23.7143 -0.0953489 24.3326 0.286047 24.714C0.47672 24.9047 0.726671 25 0.976622 25C1.22657 25 1.47647 24.9047 1.6672 24.714L12.5 13.8811L23.3328 24.714C23.5235 24.9047 23.7735 25 24.0234 25C24.2734 25 24.5233 24.9047 24.714 24.714C25.0954 24.3326 25.0954 23.7142 24.714 23.3329L13.8811 12.5Z" fill="white"/>
      </svg>
    </button>
    <div class="info-modal__body">

      <div class="popup-btn-wrap">
        <button type="button" class="btn btn-main" v-if="showEditButton" v-on:click="clickEdit()" >
          {{$t('message["general.edit"]')}}
        </button>
        <button type="button" class="btn btn-main"  v-on:click="clickDelete()" >
          {{$t('message["workout-log.mark-incomplete"]')}}
        </button>
        <button type="button" class="btn btn-main btn-main--with-only-outline"  v-on:click="closePopup" >
          {{$t( "message['general.cancel']" )}}
        </button>
      </div>

    </div>
  </b-modal>
</template>

<script>

import popupAnimationMixin from '../../../../../mixins/popupAnimationMixin'

export default {
  name: 'popup-workout-log-modify',
  props: ['visible'],
  mixins: [popupAnimationMixin],
  data: function () {
    return {
      title: '',
      imagesUrl: this.$appConfig.imagesUrl,
      showEditButton: true
    }
  },
  methods: {
    clickDelete () {
      this.$emit('delete')
    },
    clickEdit () {
      this.$emit('edit')
    },
    closePopup (e) {
      if (e) {
        e.preventDefault()
      }
      this.closeAnimatedPopup(() => {
        this.$emit('close')
      })
    }

  }
}
</script>
